import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import ResidentPageWidget from './residentPageWidget'

function Resident() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent red'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <ResidentPageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default Resident